var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPanelDocsIcon = function SvgPanelDocsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFCD66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M9 7.022h7v.603H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M15.947 8.111H8.504a.735.735 0 0 1-.723-.778.78.78 0 0 1 .723-.777h7.443a.39.39 0 0 0 0-.778H8.504a1.556 1.556 0 0 0-1.501 1.555 2 2 0 0 0 0 .19.4.4 0 0 0 0 .094v9.05a1.556 1.556 0 0 0 1.5 1.555h7.444a.39.39 0 0 0 .39-.389V8.527a.416.416 0 0 0-.39-.416m-.389 9.334H8.504a.78.78 0 0 1-.723-.778V8.714c.22.122.47.182.723.175h7.054z"
  })));
};
export default SvgPanelDocsIcon;